import { HistoryLogComponent } from './history-log.component';
export var historyLogRoutes = [
    {
        path: 'historyLog',
        component: HistoryLogComponent,
        data: {
            'expectedRoles': ['Admin']
        },
    }
];
var HistoryLogRoutingModule = (function () {
    function HistoryLogRoutingModule() {
    }
    return HistoryLogRoutingModule;
}());
export { HistoryLogRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log-routing.module.ts.pre-build-optimizer.js